import type { GetApiV1ThreeLetterCodePartnerAdminsContractPlans200 } from '@fukuri-admins/apis/client/gen/model';
import { formatDate } from '@fukuri-admins/utils/common/date/formatDate';
import { formatGiftPlan } from '~/utils/formatGiftPlan';
import type { ContractPlanListPresentation } from '../../presentations';

type PresentationProps = React.ComponentProps<typeof ContractPlanListPresentation>;

type Args = {
  /** API レスポンス全体 */
  data: GetApiV1ThreeLetterCodePartnerAdminsContractPlans200;
};

type IConvertToPresentationProps = (args: Args) => {
  rows: PresentationProps['rows'];
  /** データが 0 件か（Container が Empty 表示の出し分けに使う） */
  isEmpty: boolean;
};

/**
 * ContractPlanList の API レスポンスを Presentation Props に変換する
 *
 * - 廃止プランを含む全プランを表示する（PartnerAdmin の方針）
 * - PartnerAdminContractPlan を ContractPlanRow に変換する
 * - ページネーション（pager）の組み立ては Container 層（generatePagerProps）が担う
 */
export const convertToPresentationProps: IConvertToPresentationProps = ({ data }) => {
  const rows = (data.contract_plans ?? []).map(plan => ({
    id: plan.id,
    name: plan.name,
    kindBadge:
      plan.kind === 'custom'
        ? { label: '個社', status: 'info' as const }
        : { label: '標準', status: 'neutral' as const },
    giftPlan: formatGiftPlan(plan.gift_plan),
    customerChargeUnitPrice: `${plan.customer_charge_unit_price}円`,
    taxRatePercent: `${plan.tax_rate_percent}%`,
    createdAt: formatDate({
      date: new Date(plan.created_at * 1000),
      formatType: 'yyyy/MM/dd HH:mm',
    }),
  }));

  return {
    rows,
    isEmpty: rows.length === 0,
  };
};
